<div mat-dialog-title>
  <div class="dialog-header-title">Centrex UI</div>
</div>

<mat-dialog-content>
  {{'About.Version' | translate}}: v{{version}}
</mat-dialog-content>